
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VPoint from 'vux/src/components/v-chart/v-point.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'
import VArea from 'vux/src/components/v-chart/v-area.vue'
import dateFormat from 'vux/src/tools/date/format.js'

import Board from '@/components/Board.vue'
import Bestline from '@/components/Bestline.vue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { Promise } from 'q'
import { RENJU } from '@/store/modules/settings'

export default {
name: 'game',
directives: {
TransferDom,
},
components: {
Board,
Bestline,
Flexbox,
FlexboxItem,
XButton,
Scroller,
LoadMore,
XTable,
XTextarea,
Actionsheet,
XProgress,
Group,
Popup,
VChart,
VPoint,
VLine,
VScale,
VArea,
},
data: function () {
return {
aiTimeUsed: 0,
showBalanceOptions: false,
showFlipOptions: false,
showMoveOptions: false,
showScreenshotOptions: false,
showScreenshot: false,
console: console,
evalData: [
{ index: 0, eval: 0, piece: this.$t('game.black') },
{ index: 0, eval: 0, piece: this.$t('game.white') },
],
thinkingCanceled: false,
gifLoading: false,
screenshotData: null,
previewPv: null,
}
},
computed: {
...mapState(['screenWidth', 'screenHeight', 'isIOS']),
...mapState('settings', [
'boardSize',
'indexOrigin',
'rule',
'nbest',
'aiThinkBlack',
'aiThinkWhite',
'showAnalysis',
]),
...mapState('ai', ['outputs', 'thinking', 'lastThinkTime', 'ready']),
...mapState('position', ['position', 'lastPosition', 'winline', 'swaped']),
...mapGetters('settings', ['turnTime', 'matchTime', 'gameRule']),
...mapGetters('ai', ['bestlineStr', 'bestline']),
...mapGetters('position', ['isEmpty', 'playerToMove', 'moveLeftCount', 'posStr']),
buttonBarWidth() {
const MinWidth = 660
const MaxWidth = 740
if (this.screenWidth >= 1024)
return Math.min(MaxWidth, MinWidth + Math.max(0, this.screenWidth - 1024))
else return MaxWidth
},
chartWidth() {
if (this.screenWidth >= 1024 && this.screenWidth / this.screenHeight >= 4 / 3) {
const MarginSum = 30 + 2 * Math.min(20, Math.max(0, 0.3 * this.screenWidth - 350))
const MaxWidth = 600

return Math.min(
this.screenWidth -
Math.max(this.$store.getters.boardCanvasWidth, this.buttonBarWidth) -
MarginSum,
MaxWidth
)
} else {
return this.screenWidth
}
},
bestline() {
return this.bestlineStr(0)
},
balanceOptions() {
return [this.$t('game.balance1'), this.$t('game.balance2')]
},
flipOptions() {
return [
this.$t('game.flip') + ' |',
this.$t('game.flip') + ' -',
this.$t('game.flip') + ' ╲',
this.$t('game.flip') + ' ╱',
]
},
moveOptions() {
return [
this.$t('game.move') + ' ↑',
this.$t('game.move') + ' ↓',
this.$t('game.move') + ' ←',
this.$t('game.move') + ' →',
]
},
shotOptions() {
return [this.$t('game.shotJpg'), this.$t('game.shotGif')]
},
isAITurn() {
return (
(this.playerToMove == 'BLACK' && this.aiThinkBlack) ||
(this.playerToMove == 'WHITE' && this.aiThinkWhite)
)
},
gameEnded() {
return this.winline.length > 0 || this.moveLeftCount == 0
},
},
methods: {
...mapMutations('position', {
newBoard: 'new',
setSwaped: 'setSwaped',
}),
...mapMutations('settings', ['setValue']),
...mapMutations('ai', ['clearUsedTime']),
...mapActions('position', [
'setPosStr',
'makeMove',
'backToBegin',
'backward',
'forward',
'forwardToEnd',
'rotate',
'flip',
'moveTowards',
]),
...mapActions('ai', ['think', 'stop', 'restart', 'initEngine']),

checkThinking() {
return new Promise((resolve) => {
if (this.thinking) {
this.$vux.confirm.show({
title: this.$t('game.interruptThinking.title'),
content: this.$t('game.interruptThinking.msg'),
confirmText: this.$t('common.confirm'),
cancelText: this.$t('common.cancel'),
onCancel: () => {},
onConfirm: () => {
this.thinkingCanceled = true
this.stop()
resolve()
},
})
} else resolve()
})
},

onFlipOption(key) {
switch (key) {
case 0:
this.flip([1, 0])
break
case 1:
this.flip([0, 1])
break
case 2:
this.flip([0, 0])
break
case 3:
this.flip([1, 1])
break
}
},

onMoveOption(key) {
switch (key) {
case 0:
this.moveTowards([0, -1])
break
case 1:
this.moveTowards([0, 1])
break
case 2:
this.moveTowards([-1, 0])
break
case 3:
this.moveTowards([1, 0])
break
}
},

onScreenshotOption(key) {
let _this = this
let confirm = this.$vux.confirm
let delayPrompt = this.$t('game.gifDelay')
let startIndex, delay
switch (key) {
case 0:
this.screenshotData = { url: this.$refs.board.screenshot(), ext: 'jpg' }
this.$refs.screenshot.setAttribute('src', this.screenshotData.url)
this.showScreenshot = true
break
case 1:
confirm.prompt('', {
title: this.$t('game.gifStart'),
inputAttrs: { type: 'number', min: 1, max: this.position.length },
confirmText: this.$t('common.confirm'),
cancelText: this.$t('common.cancel'),
onShow() {
confirm.setInputValue('1')
},
onConfirm(v) {
startIndex = +v
if (isNaN(startIndex)) startIndex = 1
startIndex = Math.max(0, Math.min(startIndex - 1, _this.position.length))
confirm.prompt('', {
title: delayPrompt,
inputAttrs: { type: 'number', min: 100 },
confirmText: _this.$t('common.confirm'),
cancelText: _this.$t('common.cancel'),
onShow() {
confirm.setInputValue('1000')
},
onConfirm(v) {
delay = +v
if (isNaN(delay)) delay = 1000
delay = Math.max(100, delay)
_this.gifLoading = true
_this.$refs.screenshot.setAttribute('src', '')
_this.showScreenshot = true
_this.$refs.board.exportGIF(startIndex, delay, (blob) => {
_this.gifLoading = false
_this.screenshotData = { url: URL.createObjectURL(blob), ext: 'gif' }
_this.$refs.screenshot.setAttribute('src', _this.screenshotData.url)
})
},
})
},
})
break
}
},
saveScreenshot() {
function downloadBlobURL(blobUrl, name) {

const link = document.createElement('a')


link.href = blobUrl
link.download = name


document.body.appendChild(link)



link.dispatchEvent(
new MouseEvent('click', {
bubbles: true,
cancelable: true,
view: window,
})
)


document.body.removeChild(link)
}

downloadBlobURL(
this.screenshotData.url,
`screenshot-${dateFormat(new Date(), 'YYYYMMDDHHmmss')}.${this.screenshotData.ext}`
)
},

newGame() {
this.checkThinking().then(() => {
this.newBoard(this.boardSize)
this.restart()
})
},

clicked(e) {
let pos = [e.x, e.y]
if (this.thinking) return

if (e.button == 0) {
if ((this.isEmpty(pos) && this.winline.length == 0) || this.isAITurn) {
if (!this.isAITurn) {
if (this.rule == 5 && !this.swaped && this.position.length == 1) {

return this.$vux.confirm.show({
title: this.$t('game.swap.questionTitle'),
content: this.$t('game.swap.questionMsg'),
confirmText: this.$t('common.confirm'),
cancelText: this.$t('common.cancel'),
onCancel: () => {
this.setSwaped()
},
onConfirm: () => {
this.swapBlackAndWhite()
if (this.isAITurn) this.startThink()
},
})
} else if (this.gameRule == RENJU) {
let isForbidPos = false
for (let forbidPos of this.outputs.forbid) {
if (pos[0] == forbidPos[0] && pos[1] == forbidPos[1]) {
isForbidPos = true
break
}
}
if (isForbidPos) {
return this.$vux.alert.show({
title: this.$t('game.forbid.title'),
content: this.$t('game.forbid.msg'),
})
}
}

this.makeMove(pos)
}
if (this.isAITurn) this.startThink()
}
} else if (e.button == 2) {
this.backward()
this.clearUsedTime()
}
},

startThink() {
if (this.gameEnded) return

this.think().then((pos) => {
if (this.thinkingCanceled) {
this.thinkingCanceled = false
return
}

if (this.outputs.swap) {
this.swapBlackAndWhite()
this.$vux.alert.show({
title: this.$t('game.swap.title'),
content: this.$t('game.swap.msg'),
onHide() {
if (this.isAITurn) this.startThink()
},
})
} else {
this.makeMove(pos)

let e = +this.outputs.pv[0].eval
if (!isNaN(e)) {
this.evalData.push({
index: this.position.length,
eval: e,
piece: this.playerToMove == 'BLACK' ? this.$t('game.white') : this.$t('game.black'),
})
}

if (this.isAITurn) this.startThink()
}
})
},

startThinkBalance(mode) {
if (this.gameEnded) return

this.think({ balanceMode: mode }).then((pos) => {
if (this.thinkingCanceled) {
this.thinkingCanceled = false
return
}

if (mode == 2) {
let pos2 = this.outputs.pv[0].bestline[1]
pos2 = [pos2[0], this.boardSize - 1 - pos2[1]] 

this.makeMove(pos)
this.makeMove(pos2)
} else {
this.makeMove(pos)
}
})
},

swapBlackAndWhite() {
this.setSwaped()
let thinkBlack = this.aiThinkWhite
let thinkWhite = this.aiThinkBlack
this.setValue({ key: 'aiThinkBlack', value: thinkBlack })
this.setValue({ key: 'aiThinkWhite', value: thinkWhite })
},

setPvAsPosition(pv) {
this.checkThinking().then(() => {
let fullPosition = pv.position.concat(pv.pv)
this.newBoard(this.boardSize)
for (let pos of fullPosition) {
if (!this.makeMove(pos)) break
}
})
},
},
watch: {
bestline: function () {
if (this.$refs.bestlineArea) this.$refs.bestlineArea.updateAutosize()
},
posStr: function (newPos) {
this.$refs.curposArea.updateAutosize()
let oldIndex = this.evalData[this.evalData.length - 1].index
let newIndex = Math.max(this.position.length, 1)
if (newIndex < oldIndex) {
for (let i = this.evalData.length - 1; i > 0; i--) {
if (this.evalData[i].index > newIndex) this.evalData.pop()
}
}
if (newPos.length > 0) this.$router.push({ name: 'game', params: { pos: newPos } })
else this.$router.push({ name: 'game' })
},
boardSize: function (newSize) {
if (this.thinking) this.stop()
this.newBoard(newSize)
this.restart()
},
},
mounted() {
this.newBoard(this.boardSize)
if (this.$route.params.pos) this.setPosStr(this.$route.params.pos)

setInterval(() => {
this.aiTimeUsed = this.thinking ? Date.now() - this.lastThinkTime : 0
}, 100)

this.initEngine()
},
beforeRouteEnter(to, from, next) {
next((vm) => {
if (vm.posStr.length > 0) vm.$router.push({ name: 'game', params: { pos: vm.posStr } })
else vm.$router.push({ name: 'game' })
})
},
}
